const getQueryItem = (key: string, query: string): string => {
  if (!query) {
    return "";
  }
  const regex = new RegExp(`${key}=([^&]+)`);
  const match = query.match(regex);
  return match ? match[1] : "";
};

export default getQueryItem;
